// On the custom domain, /api/* is routed to the worker. On *.pages.dev (no
// route), fall back to the worker's direct URL so dev/preview still works.
const BASE = typeof window !== "undefined" && window.location.hostname.endsWith(".pages.dev")
    ? "https://pos-to-go-api.hdvictoriamx.workers.dev"
    : "";
export async function createCheckout(args) {
    const res = await fetch(`${BASE}/api/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            items: args.cart.map((i) => ({ sku: i.sku, qty: i.qty })),
            customer_name: args.customerName,
            language: args.language,
        }),
    });
    if (!res.ok)
        throw new Error("checkout failed: " + res.status);
    return res.json();
}
export async function getOrderStatus(orderId) {
    const res = await fetch(`${BASE}/api/orders/${orderId}`);
    if (!res.ok)
        throw new Error("status fetch failed: " + res.status);
    return res.json();
}
export async function cancelOrder(orderId) {
    await fetch(`${BASE}/api/orders/${orderId}/cancel`, { method: "POST" });
}
export async function getUpsell(args) {
    const res = await fetch(`${BASE}/api/upsell`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            items: args.cart.map((i) => ({ sku: i.sku, qty: i.qty })),
            language: args.language,
        }),
    });
    if (!res.ok)
        return null;
    return res.json();
}
